import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TimePeriodSelector = ({ selectedPeriod, onPeriodChange, selectedFacility, onFacilityChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const timePeriods = [
    { value: 'current-quarter', label: 'Current Quarter', shortLabel: 'Q4 2024' },
    { value: 'last-quarter', label: 'Last Quarter', shortLabel: 'Q3 2024' },
    { value: 'ytd', label: 'Year to Date', shortLabel: 'YTD 2024' },
    { value: 'last-year', label: 'Last Year', shortLabel: '2023' },
    { value: 'custom', label: 'Custom Range', shortLabel: 'Custom' }
  ];

  const facilities = [
    { value: 'all', label: 'All Facilities', count: '4 locations' },
    { value: 'main-plant', label: 'Main Plant', count: 'Detroit, MI' },
    { value: 'west-facility', label: 'West Facility', count: 'Phoenix, AZ' },
    { value: 'east-facility', label: 'East Facility', count: 'Atlanta, GA' },
    { value: 'north-facility', label: 'North Facility', count: 'Chicago, IL' }
  ];

  const getCurrentPeriodLabel = () => {
    const period = timePeriods?.find(p => p?.value === selectedPeriod);
    return period ? period?.shortLabel : 'Q4 2024';
  };

  const getCurrentFacilityLabel = () => {
    const facility = facilities?.find(f => f?.value === selectedFacility);
    return facility ? facility?.label : 'All Facilities';
  };

  return (
    <div className="flex items-center space-x-4">
      {/* Time Period Selector */}
      <div className="relative">
        <Button
          variant="outline"
          onClick={() => setIsOpen(!isOpen)}
          iconName="Calendar"
          iconPosition="left"
          className="min-w-[140px] justify-between"
        >
          <span>{getCurrentPeriodLabel()}</span>
          <Icon name="ChevronDown" size={16} className="ml-2" />
        </Button>

        {isOpen && (
          <div className="absolute top-full left-0 mt-2 w-64 bg-popover border border-border rounded-lg shadow-lg z-50">
            <div className="p-2">
              <div className="text-xs font-medium text-muted-foreground px-3 py-2 mb-1">
                Time Period
              </div>
              {timePeriods?.map((period) => (
                <button
                  key={period?.value}
                  onClick={() => {
                    onPeriodChange(period?.value);
                    setIsOpen(false);
                  }}
                  className={`w-full flex items-center justify-between px-3 py-2 text-sm rounded-md hover:bg-muted transition-colors ${
                    selectedPeriod === period?.value ? 'bg-muted text-foreground' : 'text-muted-foreground'
                  }`}
                >
                  <span>{period?.label}</span>
                  {selectedPeriod === period?.value && (
                    <Icon name="Check" size={16} className="text-primary" />
                  )}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
      {/* Facility Selector */}
      <div className="flex items-center space-x-2">
        <Icon name="Building2" size={16} className="text-muted-foreground" />
        <select
          value={selectedFacility}
          onChange={(e) => onFacilityChange(e?.target?.value)}
          className="bg-background border border-border rounded-md px-3 py-2 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
        >
          {facilities?.map((facility) => (
            <option key={facility?.value} value={facility?.value}>
              {facility?.label}
            </option>
          ))}
        </select>
      </div>
      {/* Export Button */}
      <Button
        variant="outline"
        iconName="Download"
        iconPosition="left"
        className="ml-auto"
      >
        Export Report
      </Button>
      {/* Print Button */}
      <Button
        variant="ghost"
        iconName="Printer"
        size="icon"
        onClick={() => window.print()}
      />
    </div>
  );
};

export default TimePeriodSelector;